<template>
  <AgreementLoader
      v-if="loading"
      :token="token"
      @agreementData="onGetAgreement"
      @error="onError"
  >
  </AgreementLoader>
  <ErrorPage v-if="errorCode != null" :errorcode="errorCode"></ErrorPage>
  <div class="main" v-if="errorCode">
    <BrandingInfo/>
  </div>
</template>
<script>
import {BASE_URLS} from "@/services/urlService";
import axios from "axios";
import AgreementLoader from "../components/AgreementLoader";
import ErrorPage from "@/components/ErrorPage.vue";
import BrandingInfo from "@/components/BrandingInfo.vue";

export default {
  name: "AgreementPage",
  components: {
    BrandingInfo,
    ErrorPage,
    AgreementLoader
  },
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      agreementEvent: null,
      errorCode: null,
    };
  },
  methods: {
    onGetAgreement(event) {

      const agreement = event.data;
      if (agreement.provider === 'VIPPS') {
        this.processVippsAgreement(agreement.referenceId);
      }
    },

    processVippsAgreement(referenceId) {
      const url = `${BASE_URLS.PROCESSOR}/v4/agreement/vipps/init/reference/${referenceId}`;
      axios.post(url, {}, {
        headers: {'Authorization': `Bearer ${this.token}`}
      }).then((response) => {
        const redirectUrl = response.data.redirectUrl;
        this.loading = false;
        window.location.href = redirectUrl;
      });
    },

    onError(error) {
      this.errorCode = error.response.status;
      this.loading = false;
    },
  },
};
</script>